import request from './base/http';

//答卷列表操作

export default {
  // 获取答题卡类型
  GetAcCardTypeList(data) {
    return request({
      method: 'post',
      url: '/AcCard/GetAcCardTypeList',
      data,
    });
  },
  // 答卷列表
  GetAcCardList(data) {
    return request({
      method: 'post',
      url: '/AcCard/GetAcCardList',
      data,
    });
  },
  // 添加答卷
  AddAcCard(data) {
    return request({
      method: 'post',
      url: '/AcCard/AddAcCard',
      data,
    });
  },
  // 编辑答卷
  EditAcCard(data) {
    return request({
      method: 'post',
      url: '/AcCard/EditAcCard',
      data,
    });
  },
  // 删除答卷
  DeleteAcCard(data) {
    return request({
      method: 'post',
      url: '/AcCard/DeleteAcCard',
      data,
    });
  },
  // 复用答卷
  MultiplexAcCard(data) {
    return request({
      method: 'post',
      url: '/AcCard/MultiplexAcCard',
      data,
    });
  },
  // 下载答卷
  DownloadAcCard(data) {
    return request({
      method: 'get',
      url: '/CardQuest/DownStr',
      params: data,
    });
  },
  // 下载答卷
  DownloadAcCardPDF(data) {
    return request({
      method: 'get',
      url: '/AcCard/DownloadAcCard',
      params: data,
    });
  },

  // 获取科目和学段
  GetKMAndPeriod(data) {
    return request({
      method: 'post',
      url: '/AcCard/GetKMAndPeriod',
      data,
    });
  },
  // 获取模板列表
  GetTemplateCardList(data) {
    return request({
      method: 'post',
      // url:'/AcCard/GetTemplateCardList',
      url: '/AcCard/GetMyTemplateCardList',
      data,
    });
  },
  // 使用模板
  MultiplexAcCardTemplate(data) {
    return request({
      method: 'post',
      url: '/AcCard/MultiplexAcCardTemplate',
      data,
    });
  },
  // 根据我的模版生成答题卡
  TemplateToCard(data) {
    return request({
      method: 'post',
      url: '/AcCard/TemplateToCard',
      data,
    });
  },
  // 根据我的答题卡添加成我的模版（添加模板）
  CardToTemplate(data) {
    return request({
      method: 'post',
      url: '/AcCard/CardToTemplate',
      data,
    });
  },
  // 修改模版对应的分类
  EditTemplateType(data) {
    return request({
      method: 'post',
      url: '/AcCard/EditTemplateType',
      data,
    });
  },
  // 删除模版
  DelCardTemplate(data) {
    return request({
      method: 'post',
      url: '/AcCard/DelCardTemplate',
      data,
    });
  },
  // 判断分享码是否存在，并且获取对应答题卡的名称
  GetShareCardName(data) {
    return request({
      method: 'post',
      url: '/AcCard/GetShareCardName',
      data,
    });
  },
  // 根据分享码导入对应模版
  ShareToCard(data) {
    return request({
      method: 'post',
      url: '/AcCard/ShareToCard',
      data,
    });
  },
  // 获取分享码
  GetShareCard(data) {
    return request({
      method: 'post',
      url: '/AcCard/GetShareCard',
      data,
    });
  },
  // 上传word新增答题卡
  UploadFileDoc(data, params) {
    return request({
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      url: '/cardquest/UploadFileDoc',
      data,
      params: params,
    });
  },
  // 获取导入答题卡接口文档
  GetFileDoc(data) {
    return request({
      method: 'get',
      url: '/cardquest/GetFileDoc',
      params: data,
    });
  },
};
